import React from 'react';
import { object, func, bool} from 'prop-types';
import style from './style';

function RecipeListItem({recipe, checked, onClick, ...props}) {
	const thumbFromCount = (recipe.thumbFrom && recipe.thumbFrom.length) || 0;
	const likeFromCount = (recipe.likeFrom && recipe.likeFrom.length) || 0;
	return(
		<style.ListItem 
			onClick={onClick}
			{...props}
		>
			<style.TitleWrapper>
				<style.Title checked={checked}>{recipe.name}</style.Title>
				<div>
					{likeFromCount > 0 && 
						(<React.Fragment>
							<style.StarIcon />
							{likeFromCount}
						</React.Fragment>)}
					{thumbFromCount > 0 && 
							(<React.Fragment>
								<style.ThumbsUpIcon />
								{thumbFromCount}
							</React.Fragment>)}
				</div>
			</style.TitleWrapper>
			
			<style.Description>{recipe.discription}</style.Description>
		</style.ListItem>
	);
}
RecipeListItem.propTypes = {
	checked : bool,
	recipe:object,
	onClick:func,
	onChange:func
};

export default RecipeListItem;